import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from 'src/app/notification.service';
import { LeadSubStatusService } from 'src/app/shared/services/leadSubStatusService';
import { TblLeadSubStatus } from 'src/app/shared/models/leadsubstatus';
import { TblLeadStatus } from 'src/app/shared/models/leadstatus';
import { LeadStatusService } from 'src/app/shared/services/leadStatus.services';
import { ConfirmDialogComponent } from 'src/app/shared/dialogs/confirm-dialog/confirm-dialog.component';
import { LocalStorageService } from 'src/app/utility/localStorageService';
import { EditLeadSubStatusDialogComponent } from './edit-lead-sub-status-dialog.component';
import { PagerService } from 'src/app/shared/pagination';

@Component({
  selector: 'app-status',
  templateUrl: './lead-sub-status.component.html',
  styleUrls: ['./lead-sub-status.component.css']
})
export class LeadSubStatusComponent implements OnInit {
  TblLeadSubStatus: TblLeadSubStatus;
  subleadStatus: Observable<TblLeadSubStatus[]>;
  allItems: TblLeadSubStatus[] = [];
  pagedItems: TblLeadSubStatus[] = [];
  pager: any = {};
  leadStatus: Observable<TblLeadStatus[]>;
  userType: string;
  constructor(private _leadSubStatusService : LeadSubStatusService,
    private _leadStatusService: LeadStatusService,
    private dialog: MatDialog,
    private modalService: BsModalService,
    private localStorage:LocalStorageService,
    private spinnerService: AppComponent,
    private notifyService: NotificationService,
    private pagerService: PagerService) {
  }

  ngOnInit(): void {
    this.userType = this.localStorage.get("userType")
    this.TblLeadSubStatus=new TblLeadSubStatus();
    this.getAllData();
  }
  getAllLeadData(){
    this.leadStatus= this._leadStatusService.getAllLeadStatus();
  }
  getAllData(){
    this.subleadStatus= this._leadSubStatusService.getAllLeadSubStatus();
    this.subleadStatus.subscribe(data => {
      this.allItems = data || [];
      this.setPage(1);
    });
  }
  
  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.allItems.length, page, 8);
    this.pagedItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
  sidePanel(id,isEditing){
    this.getAllLeadData()
    this._leadSubStatusService.getLeadSubStatusById(id)
    .subscribe(
      resp=>{
        const dialogRef = this.dialog.open(EditLeadSubStatusDialogComponent, {
          width: '500px',
          data: { title: isEditing ? 'Edit Lead Status' : 'New Lead Sub-Status', model: resp, isEditing: isEditing }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result && result.action === 'save') {
            this.TblLeadSubStatus = result.model;
            this.create_edit_after_dialog(isEditing);
          }
        });
      },
      (error: HttpErrorResponse) => {
      });
  }

  openAddDialog() {
    this.getAllLeadData();
    const model = new TblLeadSubStatus();
    const dialogRef = this.dialog.open(EditLeadSubStatusDialogComponent, {
      width: '500px',
      data: { title: 'New Lead Sub-Status', model: model, isEditing: false }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.action === 'save') {
        this.TblLeadSubStatus = result.model;
        this.create_edit_after_dialog(false);
      }
    });
  }

  openEditDialog(id: any) {
    this.getAllLeadData();
    this.sidePanel(id, true);
  }


  //Editing Data
  validateForm():boolean{
    if(!this.TblLeadSubStatus.subStatusName){
      this.notifyService.showError("Sub Status can not be empty!", "Error");
      return false;
    }
    else {
      return true;
    }
  }
  deleteClick(id:any)
  {
    let modalConfig: any = { animated: true, keyboard: true, backdrop: true, ignoreBackdropClick: false };
    const initialState = {mode:'Delete',  module: 'Lead Sub-Status', refNo:id};
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, modalConfig, { class: 'modal-sm', initialState }))
  }
  create_edit_after_dialog(isEditing: boolean){
    if(!this.validateForm()){
      return;
    }
    this._leadSubStatusService.saveAndUpdateLeadSubStatus(this.TblLeadSubStatus).subscribe(resp=>{
      if(resp.refNo>0){
        this.notifyService.showSuccess(isEditing ? "Updated Successfully!" : "Saved Successfully!", "Success");
        this.getAllData()
      }
      else{
        this.notifyService.showError(resp.message, "Error")
      }
    },(err) => {
      this.notifyService.showError(err, "Error")
    });
  }
  close_clicked()
  {
    this.getAllData();
  }
  stopPropagation(event){
    event.stopPropagation();
    }
  searchTable() {
    var term, table;
    term=document.getElementById("myInput") as unknown as HTMLInputElement
    // get term to search
    term = term.value.toLowerCase();
    table =document.getElementById("myTable") as HTMLTableElement
    // get table rows, handle as array.
    table = Array.from(table.rows);

    // filter non-matching rows; these are set to display='none'
    table.filter(function(el) {
        return el.textContent.toLowerCase().indexOf(term) ==
            -1
    }).map(x => x.style.display = "none");

    // filter matching rows; these are set to display =''
    table.filter(function(el) {
        return el.textContent.toLowerCase().indexOf(term) > -1
    }).map(x => x.style.display = "");
}
}
